console.debug('src/addons/test.js from node_modules')
